import { network } from 'services/network';

export const getRolesList = () => {
    return network.get('admin/bo/getRolesList').then((response) => {
        return response.data;
    });
};
